import { render } from "./ExternalExamReportPreview.vue?vue&type=template&id=5208f860&scoped=true"
import script from "./ExternalExamReportPreview.vue?vue&type=script&lang=js"
export * from "./ExternalExamReportPreview.vue?vue&type=script&lang=js"

import "./ExternalExamReportPreview.vue?vue&type=style&index=0&id=5208f860&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5208f860"]])

export default __exports__